import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2529d779"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "login-main" }
const _hoisted_3 = { class: "welcome-message" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "welcome-text" }, [
  /*#__PURE__*/_createTextVNode(" 우리 모두가 함께 만들어가는"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "행복한 출퇴근길")
], -1 /* HOISTED */))
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  class: "login-help-wrapper",
  "aria-label": "로그인 옵션 및 도움말"
}
const _hoisted_8 = { class: "auto-login__container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "divider",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!$setup.shouldHideNavBarBtn)
          ? (_openBlock(), _createBlock($setup["NavigationBar"], {
              key: 0,
              title: "로그인",
              shouldHideBackButton: $setup.shouldHideNavBarBtn,
              shouldHideCloseButton: $setup.shouldHideNavBarBtn,
              overrideOnClickBack: true,
              onOnClickBack: $setup.goToMainLogout
            }, null, 8 /* PROPS */, ["shouldHideBackButton", "shouldHideCloseButton"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("main", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("img", {
              class: "welcome-message__logo",
              src: $setup.logoPath,
              alt: "로고"
            }, null, 8 /* PROPS */, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode($setup["Form"], { "validation-schema": $setup.schema }, {
              default: _withCtx(({ meta }) => [
                _createElementVNode("fieldset", null, [
                  _createVNode($setup["TextInput"], {
                    class: "form-group__id",
                    name: "id",
                    type: "text",
                    placeholder: "사원번호",
                    value: $setup.userId,
                    "onUpdate:value": [
                      _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event)),
                      $setup.resetErrorMessage
                    ]
                  }, null, 8 /* PROPS */, ["value"]),
                  _createVNode($setup["PasswordInput"], {
                    class: "form-group__pw",
                    name: "password",
                    placeholder: `비밀번호(${$setup.passwordPlaceholder})`,
                    showToggleBtn: true,
                    errorMessage: $setup.loginErrorMessage,
                    value: $setup.password,
                    "onUpdate:value": [
                      _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event)),
                      $setup.resetErrorMessage
                    ]
                  }, null, 8 /* PROPS */, ["placeholder", "errorMessage", "value"])
                ]),
                _createElementVNode("section", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode($setup["CheckboxInput"], {
                      value: $setup.isAutoLogin,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($setup.isAutoLogin) = $event)),
                      title: "자동 로그인",
                      "aria-label": 
                    '자동 로그인 ' + ($setup.isAutoLogin ? '선택됨' : '선택 안됨')
                  
                    }, null, 8 /* PROPS */, ["value", "aria-label"])
                  ]),
                  _createElementVNode("nav", {
                    class: "login-help",
                    "aria-label": "로그인 도움말 메뉴"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "find-id-pw",
                      onClick: $setup.goToFindLoginInfo,
                      "aria-label": "비밀번호 찾기 페이지로 이동"
                    }, " 비밀번호 찾기 "),
                    _hoisted_9,
                    _createElementVNode("button", {
                      type: "button",
                      class: "sign-up",
                      onClick: $setup.onClickSingUp,
                      "aria-label": "회원가입 페이지로 이동"
                    }, " 회원가입 ")
                  ])
                ]),
                _createVNode($setup["BaseButton"], {
                  class: "base-button",
                  title: "로그인",
                  disabled: !meta.valid,
                  onOnClick: $setup.onSubmit,
                  "aria-label": 
                meta.valid ? '로그인하기' : '모든 필드를 입력해주세요'
              
                }, null, 8 /* PROPS */, ["disabled", "aria-label"])
              ]),
              _: 1 /* STABLE */
            })
          ])
        ])
      ]),
      _createCommentVNode(" 임시 비밀번호로 로그인한 경우 "),
      ($setup.shouldShowChangePassword)
        ? (_openBlock(), _createBlock($setup["ChangePassword"], {
            key: 0,
            onOnClickCloseButton: _cache[3] || (_cache[3] = ($event: any) => ([$setup.toggleShowChangePassword(false), $setup.goToMainLogin()]))
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}